export const GOOGLE_MAPS_LIBRARIES = ['places', 'marker'];

type Listener = () => void;

const listeners = new Set<Listener>();

let loadRequested = false;
let providerLoaded = false;
let providerFailed = false;

function emitChange(): void {
  listeners.forEach((listener) => listener());
}

export function subscribeToGoogleMapsLoader(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestGoogleMapsLoad(): void {
  if (loadRequested) return;
  loadRequested = true;
  emitChange();
}

export function markGoogleMapsProviderLoaded(): void {
  providerLoaded = true;
  providerFailed = false;
  emitChange();
}

export function markGoogleMapsProviderFailed(): void {
  providerLoaded = false;
  providerFailed = true;
  emitChange();
}

export function isGoogleMapsLoadFailed(): boolean {
  return providerFailed;
}

export function isGoogleMapsLoadRequested(): boolean {
  return loadRequested;
}

function hasRequiredGoogleMapsRuntime(): boolean {
  return (
    typeof google !== 'undefined' &&
    typeof google.maps?.Map === 'function' &&
    typeof google.maps?.Marker === 'function' &&
    !!google.maps?.places &&
    typeof google.maps?.DirectionsService === 'function' &&
    typeof google.maps?.DirectionsRenderer === 'function' &&
    typeof google.maps?.Geocoder === 'function'
  );
}

export function isGoogleMapsLoaded(): boolean {
  return providerLoaded && hasRequiredGoogleMapsRuntime();
}

export function resetGoogleMapsLoaderStateForTests(): void {
  loadRequested = false;
  providerLoaded = false;
  providerFailed = false;
  emitChange();
}
